/** need to be updated with a handled DNS record */
// const env = process.env.REACT_APP_ENV
const env = process.env.REACT_APP_ENV
const base_url = `https://api.${env}.baltee-tech.com`; 

/** User Part **/
/** User creation is allowed with no Token, and is set in Auth Part */
export async function fetchUserAPI(token, id) {
  const url = base_url + `/user/${id}`;

  var myHeaders = new Headers();
  myHeaders.append('Authorization', token);

  var requestOptions = {
    method: 'GET',
    redirect: 'follow',
    headers: myHeaders,
  };

  const response = await fetch(url, requestOptions);

  if (response.status === 200) {
    const json = await response.json();
    return json;
  } else {
    return response.status;
  }
}

export async function deleteUserAPI(token, id) {
  const url = base_url + `/user/${id}`;

  var myHeaders = new Headers();
  myHeaders.append('Authorization', token);

  var requestOptions = {
    method: 'DELETE',
    redirect: 'follow',
    headers: myHeaders,
  };

  const response = await fetch(url, requestOptions);

  if (response.status === 200) {
    const json = await response.json();
    return json;
  } else {
    return response.status;
  }
}

export async function updateUserAPI(token, id, data) {
  const url = base_url + `/user/${id}`;

  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', token);

  var raw = JSON.stringify(data);

  var requestOptions = {
    method: 'PUT',
    redirect: 'follow',
    headers: myHeaders,
    body: raw,
  };

  const response = await fetch(url, requestOptions);

  if (response.status === 200) {
    const json = await response.json();
    return json;
  } else {
    return 'updateUserAPI: ' + response.status;
  }
}

/** Organisation Part **/
export async function fetchOrga(token, id_orga) {
  const url = base_url + `/organisation/${id_orga}`;

  var myHeaders = new Headers();
  myHeaders.append('Authorization', token);

  var requestOptions = {
    method: 'GET',
    redirect: 'follow',
    headers: myHeaders,
  };

  const response = await fetch(url, requestOptions);

  if (response.status === 200) {
    const json = await response.json();
    return json;
  } else {
    return response.status;
  }
}

/** Device Part **/
export async function fetchDevice(token, id) {
  const url = base_url + `/device/${id}`;

  var myHeaders = new Headers();
  myHeaders.append('Authorization', token);

  var requestOptions = {
    method: 'GET',
    redirect: 'follow',
    headers: myHeaders,
  };

  const response = await fetch(url, requestOptions);

  if (response.status === 200) {
    const json = await response.json();
    return json;
  } else {
    return response.status;
  }
}

/** Device Part **/
export async function fetchUserDevicesAPI(token, idUser) {
  const url = base_url + `/user/${idUser}/device`;

  var myHeaders = new Headers();
  myHeaders.append('Authorization', token);

  var requestOptions = {
    method: 'GET',
    redirect: 'follow',
    headers: myHeaders,
  };

  const response = await fetch(url, requestOptions);

  if (response.status === 200) {
    const json = await response.json();
    return json;
  } else {
    return response.status;
  }
}

export async function createDeviceAPI(token, data) {
  const url = base_url + `/device`;

  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', token);

  var raw = JSON.stringify(data);

  var requestOptions = {
    method: 'POST',
    redirect: 'follow',
    headers: myHeaders,
    body: raw,
  };

  const response = await fetch(url, requestOptions);

  if (response.status === 200 || response.status === 201) {
    const json = await response.json();
    return json;
  } else {
    return response.status;
  }
}

export async function deleteDeviceAPI(token, id) {
  const url = base_url + `/device/${id}`;

  var myHeaders = new Headers();
  myHeaders.append('Authorization', token);

  var requestOptions = {
    method: 'DELETE',
    redirect: 'follow',
    headers: myHeaders,
  };

  const response = await fetch(url, requestOptions);

  if (response.status === 200) {
    const json = await response.json();
    return json;
  } else {
    return response.status;
  }
}

export async function updateDeviceAPI(token, id, data) {
  if (!id) {
    console.warn('Erreur updateDeviceAPI ID undefined');
    return;
  }
  const url = base_url + `/device/${id}`;

  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', token);

  var raw = JSON.stringify(data);

  var requestOptions = {
    method: 'PUT',
    redirect: 'follow',
    headers: myHeaders,
    body: raw,
  };

  const response = await fetch(url, requestOptions);

  if (response.status === 200) {
    const json = await response.json();
    return json;
  } else {
    return response.status;
  }
}

/** Emergency contact Part **/
export async function fetchEmergencyContactAPI(token, idUser, idDevice) {
  const url = base_url + `/emergency_contact/user/${idUser}/device/${idDevice}/`;

  var myHeaders = new Headers();
  myHeaders.append('Authorization', token);

  var requestOptions = {
    method: 'GET',
    redirect: 'follow',
    headers: myHeaders,
  };

  const response = await fetch(url, requestOptions);

  if (response.status === 200) {
    const json = await response.json();
    return json;
  } else {
    return response.status;
  }
}

export async function createEmergencyContactAPI(token, data) {
  const url = base_url + `/emergency_contact`;

  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', token);

  var raw = JSON.stringify(data);

  var requestOptions = {
    method: 'POST',
    redirect: 'follow',
    headers: myHeaders,
    body: raw,
  };

  const response = await fetch(url, requestOptions);

  if (response.status === 200 || response.status === 201) {
    const json = await response.json();
    return json;
  } else {
    return response.status;
  }
}

export async function updateEmergencyContactAPI(token, id, data) {
  const url = base_url + `/emergency_contact/${id}`;

  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', token);

  var raw = JSON.stringify(data);

  var requestOptions = {
    method: 'PUT',
    redirect: 'follow',
    headers: myHeaders,
    body: raw,
  };

  const response = await fetch(url, requestOptions);

  if (response.status === 200) {
    const json = await response.json();
    return json;
  } else {
    return response.status;
  }
}

export async function deleteEmergencyContactAPI(token, id) {
  const url = base_url + `/emergency_contact/${id}`;

  var myHeaders = new Headers();
  myHeaders.append('Authorization', token);

  var requestOptions = {
    method: 'DELETE',
    redirect: 'follow',
    headers: myHeaders,
  };

  const response = await fetch(url, requestOptions);

  if (response.status === 200) {
    const json = await response.json();
    return json;
  } else {
    return response.status;
  }
}

export async function getLatestFirmwareVersionAPI(idDevice, idUser, token) {
  const url = base_url + `/iot/fota/${idDevice}/${idUser}/firmwares/b01/getobject`;

  var myHeaders = new Headers();
  myHeaders.append('Authorization', token);

  var requestOptions = {
    method: 'GET',
    redirect: 'follow',
    headers: myHeaders,
  };
  
  const response = await fetch(url, requestOptions);

  if (response.status === 200) {
    const json = await response.json();
    return json;
  } else {
    return response.status;
  }
}

export async function getLatestFirmwareUrlAPI(idDevice, idUser, token) {
  const url = base_url + `/iot/fota/${idDevice}/${idUser}/firmwares/b01/geturl`;

  var myHeaders = new Headers();
  myHeaders.append('Authorization', token);

  var requestOptions = {
    method: 'GET',
    redirect: 'follow',
    headers: myHeaders,
  };

  const response = await fetch(url, requestOptions);

  if (response.status === 200) {
    const json = await response.json();
    return json;
  } else {
    return response.status;
  }
}

export async function updateHardwareAPI(token, id, data) {
  const url = base_url + `/hardware/id_device/${id}`;

  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', token);

  var raw = JSON.stringify(data);

  var requestOptions = {
    method: 'PUT',
    redirect: 'follow',
    headers: myHeaders,
    body: raw,
  };

  const response = await fetch(url, requestOptions);

  if (response.status === 200) {
    const json = await response.json();
    return json;
  } else {
    return response.status;
  }
}

export async function mobileAppVersionAPI(token, OS) {
  // OS === android || ios
  if (!['android', 'ios'].includes(OS)) {
    console.warn('Invalid OS type. Must be "android" or "ios" not => ', OS);
    return;
  }
  const url = base_url + `/utils/app_version/` + OS;

  var myHeaders = new Headers();
  myHeaders.append('Authorization', token);

  var requestOptions = {
    method: 'GET',
    redirect: 'follow',
    headers: myHeaders,
  };

  const response = await fetch(url, requestOptions);

  if (response.status === 200) {
    const json = await response.json();
    return json;
  } else {
    return response.status;
  }
}

export async function fetchShippingMethode(to_country, to_postal_code, weight) {
  const url = base_url + `/sendcloud/shipping-methods?to_country=${to_country}&to_postal_code=${to_postal_code}&weight=${weight}`;

  var myHeaders = new Headers();

  var requestOptions = {
    method: 'GET',
    redirect: 'follow',
    headers: myHeaders,
  };

  const response = await fetch(url, requestOptions);

  if (response.status === 200) {
    const json = await response.json();
    return json;
  } else {
    return response.status;
  }
}

export async function fetchPickupPoint(carrier, address, country, radius = 2000) {
  const url = base_url + `/sendcloud/service-points?carrier=${carrier}&address=${address}&radius=${radius}&country=${country}`;
  // const url = "https://servicepoints.sendcloud.sc/api/v2/service-points?country=FR&carrier=colissimo&address=50%20Avenue%20George%20Clemenceau%2093160%20Noisy%20le%20grand&radius=700";

  var myHeaders = new Headers();

  var requestOptions = {
    method: 'GET',
    redirect: 'follow',
    headers: myHeaders,
  };

  const response = await fetch(url, requestOptions);

  if (response.status === 200) {
    const json = await response.json();
    return json;
  } else {
    return response.status;
  }
  
}

export async function emailListing(data) {
  const url = base_url + `/email_listing`;

  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-api-key', 'VovfoL7OuI7i9WaFFSsXe8jpsoRmQD2B7wyt2tD8');

  var raw = JSON.stringify(data);

  var requestOptions = {
    method: 'POST',
    redirect: 'follow',
    headers: myHeaders,
    body: raw,
  };

  const response = await fetch(url, requestOptions);

  if (response.status === 200 || response.status === 201) {
    const json = await response.json();
    return json;
  } else {
    return response.status;
  }
}

export async function getArticlesAPI() {
  const url = base_url + `/blog/articles`;

  var myHeaders = new Headers();

  var requestOptions = {
    method: 'GET',
    redirect: 'follow',
    headers: myHeaders,
  };

  const response = await fetch(url, requestOptions);

  if (response.status === 200) {
    const json = await response.json();
    return json;
  } else {
    return response.status;
  }
}